import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2585f3a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-tree-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_tree_node = _resolveComponent("oxd-tree-node")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createVNode(_component_oxd_tree_node, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), _createSlots({ _: 2 }, [
      _renderList(_ctx.$slots, (_, name) => {
        return {
          name: name,
          fn: _withCtx((slotData) => [
            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)), undefined, true)
          ])
        }
      })
    ]), 1040)
  ]))
}